import { Component, Inject, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import * as fromRoot from '../../reducers';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CareConstants } from '../care.constants';

@Component({
  selector: 'action-selection-dialog',
  templateUrl: 'action-selection-dialog.component.html',
  styleUrls: ['./action-selection-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class ActionSelectionDialogComponent implements OnInit {
  public name;
  public type;
  public priority;
  public eligibleForSpotEngagement;
  public isP1: boolean;
  public hasEmail$: Observable<boolean>;
  public isRecoverySendingDisabled$: Observable<boolean>;
  public p1SendingFlagEnabled$: Observable<boolean>;
  public recoverEligibilityLoading$: Observable<boolean>;
  public actionOptions$: Observable<any>;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
              public store: Store<fromRoot.State>,
              public dialogRef: MatDialogRef<ActionSelectionDialogComponent>) {
    this.isRecoverySendingDisabled$ = store.select(fromRoot.getFeatureEnabled(CareConstants.disableSendingFlag));
    this.p1SendingFlagEnabled$ = store.select(fromRoot.getFeatureEnabled(CareConstants.allowP1RewardSendingFlag));
    this.recoverEligibilityLoading$ = store.select(fromRoot.getCareRecoverEligibilityLoading);
    this.hasEmail$ = store.select(fromRoot.getCareServiceNowCase).pipe(
      map((serviceNowCase) => !!serviceNowCase?.email && serviceNowCase?.email !== 'N/A')
    );
  }

  public ngOnInit() {
    this.name = this.dialogData.fullName;
    this.type = this.dialogData.type;
    this.priority = this.dialogData.priority;
    this.eligibleForSpotEngagement = this.dialogData.eligibleForSpotEngagement;
    this.isP1 = !!this.priority && this.priority.toLowerCase().includes(CareConstants.p1PriorityIdentifier);
    if (this.type === CareConstants.spotCustomer) {
      this.actionOptions$ = this.store.select(fromRoot.getSpotStatusOptions);
    } else {
      this.actionOptions$ = this.store.select(fromRoot.getCareStatusOptionsFilteredByEmail);
    }
  }
}
